import Common from '../Common';
import ACL from './user/ACL';
import Account from './user/Account';
import Avatar from './user/Avatar';
import CID from './user/CID';
import Call from './user/Call';
import CallTravel from './user/CallTravel';
import CommonContact from './user/CommonContact';
import Contact from './user/Contact';
import DID from './user/DID';
import Device from './user/Device';
import Field from './user/Field';
import Log from './user/Log';
import Mailbox from './user/Mailbox';
import Mobile from './user/Mobile';
import OAuth from './user/OAuth';
import PbxFlow from './user/PbxFlow';
import Profile from './user/Profile';
import Provisioning from './user/Provisioning';
import Queue from './user/Queue';
import Recording from './user/Recording';
import RingGroup from './user/RingGroup';
import SMS from './user/SMS';
import StandardCallMethod from './user/StandardCallMethod';
import TFA from './user/TFA';
import Template from './user/Template';
import Users from './user/Users';
import Wallboard from './user/Wallboard';
import WallboardOutgoing from './user/WallboardOutgoing';
import GlobalSearch from './user/globalsearch';

const User = class extends Common {
	wallboard: InstanceType<typeof Wallboard>;
	acl: InstanceType<typeof ACL>;
	call: InstanceType<typeof Call>;
	queue: InstanceType<typeof Queue>;
	cid: InstanceType<typeof CID>;
	profile: InstanceType<typeof Profile>;
	account: InstanceType<typeof Account>;
	callTravel: InstanceType<typeof CallTravel>;
	oauth: InstanceType<typeof OAuth>;
	contact: InstanceType<typeof Contact>;
	users: InstanceType<typeof Users>;
	did: InstanceType<typeof DID>;
	sms: InstanceType<typeof SMS>;
	log: InstanceType<typeof Log>;
	tfa: InstanceType<typeof TFA>;
	commonContact: InstanceType<typeof CommonContact>;
	mobile: InstanceType<typeof Mobile>;
	device: InstanceType<typeof Device>;
	globalsearch: InstanceType<typeof GlobalSearch>;
	recording: InstanceType<typeof Recording>;
	ringGroup: InstanceType<typeof RingGroup>;
	avatar: InstanceType<typeof Avatar>;
	provisioning: InstanceType<typeof Provisioning>;
	mailbox: InstanceType<typeof Mailbox>;
	pbxFlow: InstanceType<typeof PbxFlow>;
	standardCallMethod: InstanceType<typeof StandardCallMethod>;
	wallboardoutgoing: InstanceType<typeof WallboardOutgoing>;
	template: InstanceType<typeof Template>;
	field: InstanceType<typeof Field>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.wallboard = new Wallboard(headers);
		this.acl = new ACL(headers);
		this.call = new Call(headers);
		this.queue = new Queue(headers);
		this.cid = new CID(headers);
		this.profile = new Profile(headers);
		this.account = new Account(headers);
		this.callTravel = new CallTravel(headers);
		this.oauth = new OAuth(headers);
		this.contact = new Contact(headers);
		this.users = new Users(headers);
		this.did = new DID(headers);
		this.sms = new SMS(headers);
		this.log = new Log(headers);
		this.tfa = new TFA(headers);
		this.commonContact = new CommonContact(headers);
		this.mobile = new Mobile(headers);
		this.device = new Device(headers);
		this.globalsearch = new GlobalSearch(headers);
		this.recording = new Recording(headers);
		this.ringGroup = new RingGroup(headers);
		this.avatar = new Avatar(headers);
		this.provisioning = new Provisioning(headers);
		this.mailbox = new Mailbox(headers);
		this.pbxFlow = new PbxFlow(headers);
		this.standardCallMethod = new StandardCallMethod(headers);
		this.wallboardoutgoing = new WallboardOutgoing(headers);
		this.template = new Template(headers);
		this.field = new Field(headers);
	}

	read = (userId?: id, adsyncInfo = false): CustomResponse<User> =>
		this.get(
			"/user" + (userId ? `/${userId}` : ""),
			{ extra: (adsyncInfo ? [ "adsync" ] : []) }
		)

	update = (userId: id, body: any): CustomResponse<User> =>
		this.patch(`/user/${userId}`, body)

	isPassword = (userId: id, password: string): CustomResponse<{ result: boolean }> =>
		this.post(`/user/${userId}/ispassword`, { password })

	isPasswordBad = (userId: id, password: string): CustomResponse<{ result: boolean }> =>
		this.post(`/user/${userId}/testpassword`, { password })

	// TODO move this
	getChoosableUserAmount = (userId: id) : CustomResponse<{ count: string }> =>
		this.get(`/user/${userId}/users/amount`)

	// TODO move this
	getChoosableCompanyAmount = (userId: id): CustomResponse<{ count: string }> =>
		this.get(`/user/${userId}/companies/amount`)
}

export default User
